import { RestSlice } from '../../../../redux/rest.slice';
import { CccTestKit } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const cccTestKitSlice = new RestSlice<CccTestKit>(
	localizationService.getLocalizedString('cccTestKit.testKits'),
	Resource.CccTestKits
);
export default cccTestKitSlice.rests.reducer;
